import {createStore,applyMiddleware,compose} from 'redux';
import thunk from 'redux-thunk';
import commonreducer from './CommonReducer.js';

const initialState={};
const middleware=[thunk];


const store=createStore(commonreducer,initialState,compose(applyMiddleware(...middleware),))

export default store
